import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['view', 'edit', 'input'];

  edit() {
    this.viewTarget.classList.add('d-none');
    this.editTarget.classList.remove('d-none');
    const input = this.inputTarget;
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  }

  cancel() {
    this.editTarget.classList.add('d-none');
    this.viewTarget.classList.remove('d-none');
  }
}
